module.exports = __webpack_public_path__ + "img/patrick-bruel-barbara.28f3c761.jpg";